import React from "react";
import "./trainingCard.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
interface CardProps {
  icon: JSX.Element;
  title: string;
  count: number;
  label: string;
  onDownload: () => void;
}

const TrainingCardComponent: React.FC<CardProps> = ({ icon, title, count, label, onDownload }) => {
  return (
    <div className="card-container xs-12 md-3">
      <div className="card-content">
        <div>
       <div className="card-icon">{icon}
       <div className="card-title">{title}</div>
       </div>
       </div> 
      <div>
        <div className="card-count">{count}</div>
        </div>
        <div>
        <FontAwesomeIcon
      icon={faDownload}
      className="download-btn"
      onClick={onDownload}
      style={{ cursor: 'pointer' }} // Add this to show it's clickable
    />
        <div className="card-label">
       
    {label}
    </div>
  
    </div>
      </div>
      {/* <button>
    <FontAwesomeIcon icon={faDownload} /> 
  </button> */}
   
    </div>
  );
};

export default TrainingCardComponent;
